'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_SendEmailSignInLinkError() {
}
export { $c_Lapp_data_SendEmailSignInLinkError as $c_Lapp_data_SendEmailSignInLinkError };
$p = $c_Lapp_data_SendEmailSignInLinkError.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_SendEmailSignInLinkError;
/** @constructor */
function $h_Lapp_data_SendEmailSignInLinkError() {
}
export { $h_Lapp_data_SendEmailSignInLinkError as $h_Lapp_data_SendEmailSignInLinkError };
$h_Lapp_data_SendEmailSignInLinkError.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
//# sourceMappingURL=app.data.-Send-Email-Sign-In-Link-Error.js.map
